import { render, staticRenderFns } from "./keyProjectSideView.vue?vue&type=template&id=5395604c"
import script from "./keyProjectSideView.vue?vue&type=script&lang=js"
export * from "./keyProjectSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports